module.exports = __webpack_public_path__ + "static/media/business-owner-Google-Search.bd4497fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/business-owner-Google-Search.jpg
// module id = 770
// module chunks = 0